/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 * 
 *  
 */

(function(window,$){
    'use strict';
    
    $(document).ready(function(){
        
        $('.article-gallery').on('click', '.more-pics', function(e){
            
            e.preventDefault();
            
            var galleryListHolder = $(this).prev('.gallery-list-holder');
            if(galleryListHolder.attr('data-full-height') == '0'){
                var galleryList = galleryListHolder.find('.gallery-list');
                //galleryListHolder.css('max-height', '100%');
                galleryListHolder.css('max-height', galleryList.innerHeight());
                $(this).text('Zwiń nadmiar zdjęć');
                galleryListHolder.attr('data-full-height',1);
            }else{
                //galleryListHolder.css('max-height', '390px');
                galleryListHolder.css('max-height', '600px');
                $(this).text('Pokaż więcej zdjęć');
                galleryListHolder.attr('data-full-height',0);
            }
            
        });
        
        lightbox.option({
            //'resizeDuration': 200,
            //'wrapAround': true,
            //'showImageNumberLabel': true,
            'albumLabel': 'Zdjęcie %1 z %2'
        });
        
        
        $('.slider').slick({
            nextArrow: '<span class="right-arrow slider-arrow"></span>',
            prevArrow: '<span class="left-arrow slider-arrow"></span>',
            slidesToShow: 4,
            slidesToScroll: 4,
            //asNavFor: '.slider-for',
            dots: false,
            centerMode: false,
            responsive: [
                {
                  breakpoint: 1200,
                  settings: {
                        arrows:false,
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true
                    }
                },
                {
                  breakpoint: 992,
                  settings: {
                        arrows: false,
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                  breakpoint: 550,
                  settings: {
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
            ]
            //focusOnSelect: true
        });

        $('.news-list-slider').slick({
            slidesToShow: 1,
            adaptiveHeight: true,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            arrows: false,
            fade: true
        });

        $('.gallery-mini-slider').slick({
            slidesToShow: 1,
            adaptiveHeight: true,
            slidesToScroll: 1,
            infinite: false,
            dots: false,
            arrows: false,
            fade: true,
            speed: 500,
            autoplay: true
            //respondTo: 'slider'
        });
        
        //alert('test');
        
        $('.email').each(function(){
            var text = $(this).text();
            text = text.replace('[dot]','.').replace('[at]','@');
            $(this).text(text).attr('href', 'mailto:'+text);
        });
        
        $("#mobile-menu").mmenu({
            extensions 	: [ "theme-white", "border-full", "shadow-page", "pagedim-black" ],
            "counters": true,
            "navbars": [
               {
                  "position": "top",
                  "content": ["close"]
               }
            ]
        });
        
    });
})(window, jQuery);



